export const FORMAT_SIZES = [
    'Bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB',
];
export const formatBytes = (bytes, decimals = 2) => {
    if (!bytes) {
        return `0 ${FORMAT_SIZES[0]}`;
    }
    const base = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizeIndex = Math.floor(Math.log(bytes) / Math.log(base));
    return `${parseFloat((bytes / Math.pow(base, sizeIndex)).toFixed(dm))} ${FORMAT_SIZES[sizeIndex]}`;
};
//# sourceMappingURL=formatBytes.js.map